import 'react/jsx-runtime';
import '@backstage/version-bridge';
import '@backstage/errors';
import { createApiRef } from '../system/ApiRef.esm.js';

var SessionState = /* @__PURE__ */ ((SessionState2) => {
  SessionState2["SignedIn"] = "SignedIn";
  SessionState2["SignedOut"] = "SignedOut";
  return SessionState2;
})(SessionState || {});
const googleAuthApiRef = createApiRef({
  id: "core.auth.google"
});
const githubAuthApiRef = createApiRef({
  id: "core.auth.github"
});
const oktaAuthApiRef = createApiRef({
  id: "core.auth.okta"
});
const gitlabAuthApiRef = createApiRef({
  id: "core.auth.gitlab"
});
const microsoftAuthApiRef = createApiRef({
  id: "core.auth.microsoft"
});
const oneloginAuthApiRef = createApiRef({
  id: "core.auth.onelogin"
});
const bitbucketAuthApiRef = createApiRef({
  id: "core.auth.bitbucket"
});
const bitbucketServerAuthApiRef = createApiRef({
  id: "core.auth.bitbucket-server"
});
const atlassianAuthApiRef = createApiRef({
  id: "core.auth.atlassian"
});
const vmwareCloudAuthApiRef = createApiRef({
  id: "core.auth.vmware-cloud"
});

export { SessionState, atlassianAuthApiRef, bitbucketAuthApiRef, bitbucketServerAuthApiRef, githubAuthApiRef, gitlabAuthApiRef, googleAuthApiRef, microsoftAuthApiRef, oktaAuthApiRef, oneloginAuthApiRef, vmwareCloudAuthApiRef };
//# sourceMappingURL=auth.esm.js.map
